<script>
  import { flatten, groupLonger, LayerCake, Svg } from "layercake";

  import MultiLine from "./MultiLine.svelte";
  import { AxisX, AxisY, Tooltip } from "@urbaninstitute/dataviz-components";
  import { scaleOrdinal } from "d3-scale";
  import { urbanColors } from "@urbaninstitute/dataviz-components/utils";
  import { percentFormat } from "$utils/formats.js";
  import { getStateName } from "$utils/states.js";

  // This example loads csv data as json and converts numeric columns to numbers using @rollup/plugin-dsv. See vite.config.js for details
  //import data from './_data/points.csv';
  let { data, currentState } = $props();

  const xKey = "year";
  const yKey = "value";
  const zKey = "region";

  let hoveredPoint = $state(null);

  const seriesNames = Object.keys(data[0]).filter((d) => d !== xKey);
  let seriesColors = [
    urbanColors.gray_shade_light,
    urbanColors.gray_shade_dark,
    urbanColors.yellow
  ];

  const groupedData = groupLonger(data, seriesNames, {
    groupTo: zKey,
    valueTo: yKey
  });
</script>

<div class="chart-container">
  <div class="legend-row">
    <div class="legend-pair">
      <div class="line" style="border-color:{seriesColors[2]};"></div>
      <div class="name">{getStateName(currentState)}</div>
    </div>
    <div class="legend-pair">
      <svg class="legend-line" width="20" height="16" viewBox="0 0 20 16">
        <line
          x1="0"
          y1="8"
          x2="20"
          y2="8"
          stroke={seriesColors[1]}
          stroke-dasharray={"4 4"}
          stroke-width="3"
          stroke-linecap="round"
        ></line>
      </svg>
      <div class="name">US</div>
    </div>
    <div class="legend-pair">
      <div class="line" style="border-color:{seriesColors[0]};"></div>
      <div class="name">Other states</div>
    </div>
  </div>
  <LayerCake
    padding={{ top: 20, right: 40, bottom: 40, left: 25 }}
    x={xKey}
    y={yKey}
    z={zKey}
    yDomain={[0.5, 2]}
    yNice={true}
    zScale={scaleOrdinal()}
    flatData={flatten(groupedData, "values")}
    data={groupedData}
    custom={{ currentState: getStateName(currentState), seriesColors: seriesColors }}
  >
    <Svg>
      <AxisX ticks={5} />
      <AxisY ticks={4} formatTick={(d) => percentFormat.format(d)} />
      <MultiLine bind:hoveredPoint />
    </Svg>
  </LayerCake>
  {#if hoveredPoint}
    <Tooltip el={hoveredPoint.target}>
      <span class="underlined">{hoveredPoint.state}</span><br /><br />
      <i>{hoveredPoint.year}:</i>
      <strong>{percentFormat.format(hoveredPoint.value).replace("%", " percent")}</strong> of 1970's
      median household income
    </Tooltip>
  {/if}
</div>

<style>
  .legend-row {
    display: flex;
    gap: 20px;
    margin-bottom: 10px;
    .legend-pair {
      display: flex;
      gap: 7px;
      align-items: center;
    }
    .line {
      height: 0px;
      width: 20px;
      border-bottom: solid black 3px;
    }
  }
  .underlined {
    border-bottom: 3px solid var(--color-yellow);
  }

  /*
    The wrapper div needs to have an explicit width and height in CSS.
    It can also be a flexbox child or CSS grid element.
    The point being it needs dimensions since the <LayerCake> element will
    expand to fill it.
  */
  .chart-container {
    width: 100%;
    height: 250px;
  }
</style>
